/**
 * Gold foil: moves the highlight on every foil surface a little as the page
 * scrolls, so the gold catches the light like metal instead of sitting flat.
 *
 * Writes `--foil-pos` on the sections that carry foil (not the root, which
 * would restyle the whole document on every frame) and only when the value
 * has moved a whole percent, so a scroll produces a handful of style updates
 * rather than sixty a second. The CSS transition on background-position
 * glides between the steps. Idle under reduced motion.
 */
import { getScrollTop, getScrollEventTarget } from '@theme/scroll-container';

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
let frame = 0;
let lastStep = -1;

function targets() {
  return document.querySelectorAll('.shopify-section:has(.gs), .gs:not(.shopify-section .gs)');
}

function update() {
  frame = 0;
  // One full sweep of the highlight per 1400px of scroll, wrapped so it never runs off.
  const step = Math.round(((getScrollTop() / 1400) % 1) * 100);
  if (step === lastStep) return;
  lastStep = step;
  const value = `${step}%`;
  for (const element of targets()) {
    element.style.setProperty('--foil-pos', value);
  }
}

function requestUpdate() {
  if (frame) return;
  frame = requestAnimationFrame(update);
}

if (!REDUCED_MOTION.matches) {
  getScrollEventTarget().addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', () => {
    lastStep = -1;
    requestUpdate();
  });
  update();
}
